(function () {

  var WRAP_ID     = 'sc-page-content';
  var SWITCHER_ID = 'sc-unit-switcher';
  var EN_DASH     = '\u2013';

  // Per-domain storage key — prevents cross-domain localStorage bleed
  var host = (window.location.hostname || '').toLowerCase().replace(/^www\./, '');
  var STORAGE_KEY = 'sc_unit_pref_' + host;

  // Inches-first domains
  var IN_PRIMARY_HOSTS = ['decrum.com', 'decrum.co.uk', 'decrum.ca'];
  // CM-first domains
  var CM_PRIMARY_HOSTS = ['decrum.com.au', 'decrum.de', 'decrum.fr', 'decrum.it', 'decrum.eu','decrum.nl','decrum.es','decrum.ch','decrum.se','decrum.at','decrum.fr','decrum.it'];
 

  // -----------------------------
  // HELPERS
  // -----------------------------
  function $(id) { return document.getElementById(id); }

  function normDash(s) {
    return (s || '').replace(/\u2013|\u2014/g, '-');
  }

  function toCm(n) { return +(n * 2.54).toFixed(1); }
  function toIn(n) { return +(n / 2.54).toFixed(1); }

  function splitRange(s) {
    s = normDash(s);
    var p = s.split('-').map(function (v) { return v.trim(); });
    return p.length > 1 ? [p[0], p[1]] : [p[0]];
  }

  // -----------------------------
  // DETERMINE DEFAULT UNIT
  // Priority: 1) per-domain saved pref  2) domain rule  3) inches fallback
  // -----------------------------
  function autoDefaultUnit() {
    var saved = null;
    try { saved = localStorage.getItem(STORAGE_KEY); } catch (e) {}
    if (saved === 'cm' || saved === 'in') return saved;
    if (CM_PRIMARY_HOSTS.indexOf(host) !== -1) return 'cm';
    return 'in'; // US / UK / CA / ES and any unknown domain
  }

  // -----------------------------
  // PARSE a raw cell value authored in inches
  // Returns { inch, cm } or null
  // -----------------------------
  function parseAsInches(txt) {
    txt = (txt || '').trim();
    if (!/\d/.test(txt)) return null;

    // Support ranges like "37 – 38" or "37-38" or single values like "37"
    var numOnly = txt.match(/[\d.]+(?:\s*[-\u2013\u2014]\s*[\d.]+)?/);
    if (!numOnly) return null;

    var nums = splitRange(numOnly[0]).map(Number);
    if (nums.some(isNaN)) return null;

    return {
      inch: nums.join(' ' + EN_DASH + ' '),
      cm:   nums.map(toCm).join(' ' + EN_DASH + ' ')
    };
  }

  // -----------------------------
  // SCAN: find all columns marked data-sc-measure="in"
  // and stamp each body cell with data-sc-in / data-sc-cm
  // -----------------------------
  function scanAndPrepare(wrap) {
    var tables = wrap.querySelectorAll('table');
    var hasConvertible = false;

    Array.prototype.forEach.call(tables, function (tbl) {

      // Find the header row
      var headerRow = tbl.querySelector('thead tr') || tbl.querySelector('tr');
      if (!headerRow) return;

      // Collect column indices that are measurement columns
      var measureCols = [];
      var headerCells = headerRow.querySelectorAll('th, td');

      Array.prototype.forEach.call(headerCells, function (cell, i) {
        if (cell.getAttribute('data-sc-measure') !== 'in') return;
        measureCols.push(i);

        // Save the original header text once so we can re-attach the unit label
        if (!cell.hasAttribute('data-sc-basehdr')) {
          cell.setAttribute('data-sc-basehdr', (cell.textContent || '').trim());
        }
      });

      // No measurement columns found in this table — skip
      if (!measureCols.length) return;

      // Process every body row
      var bodyRows = (tbl.tBodies && tbl.tBodies[0])
        ? tbl.tBodies[0].rows
        : tbl.querySelectorAll('tbody tr');

      Array.prototype.forEach.call(bodyRows, function (tr) {
        Array.prototype.forEach.call(tr.cells, function (cell, idx) {
          if (measureCols.indexOf(idx) === -1) return; // not a measurement col
          if (cell.tagName !== 'TD') return;

          // Already stamped on a previous scan — just count it
          if (cell.hasAttribute('data-sc-converted')) {
            hasConvertible = true;
            return;
          }

          var data = parseAsInches((cell.textContent || '').trim());
          if (!data) return;

          cell.setAttribute('data-sc-in',       data.inch);
          cell.setAttribute('data-sc-cm',        data.cm);
          cell.setAttribute('data-sc-converted', '1');
          hasConvertible = true;
        });
      });
    });

    return hasConvertible;
  }

  // -----------------------------
  // RENDER: write the correct unit values into every converted cell
  //         and update the unit label in the column header
  // -----------------------------
  function renderUnit(wrap, unit) {

    // Update cell text
    var tds = wrap.querySelectorAll('td[data-sc-converted]');
    Array.prototype.forEach.call(tds, function (td) {
      td.textContent = (unit === 'cm')
        ? td.getAttribute('data-sc-cm')
        : td.getAttribute('data-sc-in');
    });

    // Update header unit labels for every measurement column
    var headers = wrap.querySelectorAll('[data-sc-measure]');
    Array.prototype.forEach.call(headers, function (th) {
      var base = th.getAttribute('data-sc-basehdr') || (th.textContent || '').trim();

      // Find or create the unit label span
      var ul = th.querySelector('.unit-label');
      if (!ul) {
        // Clear the cell and rebuild: base text + label span
        th.textContent = base;
        ul = document.createElement('span');
        ul.className = 'unit-label';
        ul.style.marginLeft = '6px';
        th.appendChild(ul);
      }

      ul.textContent = (unit === 'cm') ? '(CM)' : '(IN)';
    });
  }

  // -----------------------------
  // UPDATE SWITCHER UI
  // Sets the active button and the slider position
  // -----------------------------
  function updateSwitcherUI(switcher, unit) {
    var btns = switcher.querySelectorAll('[data-unit]');
    Array.prototype.forEach.call(btns, function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-unit') === unit);
    });

    var toggle = switcher.querySelector('.sc-switch-toggle');
    if (toggle) toggle.setAttribute('data-active', unit);
  }

  // -----------------------------
  // APPLY: full cycle — scan, render, update UI
  // Called on init and after every DOM mutation
  // -----------------------------
  function applyUnit(wrap, switcher) {
    var hasConvertible = scanAndPrepare(wrap);
    if (!hasConvertible) return;

    switcher.style.display = '';

    var unit = autoDefaultUnit();
    renderUnit(wrap, unit);
    updateSwitcherUI(switcher, unit);
  }

  // -----------------------------
  // SWITCHER CLICK (event-delegated on document)
  // -----------------------------
  function bindSwitcherDelegated() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('#' + SWITCHER_ID + ' [data-unit]');
      if (!btn) return;

      var unit = btn.getAttribute('data-unit');
      if (unit !== 'cm' && unit !== 'in') return;

      var wrap     = $(WRAP_ID);
      var switcher = $(SWITCHER_ID);
      if (!wrap || !switcher) return;

      // Re-scan in case the popup was just opened for the first time
      scanAndPrepare(wrap);
      renderUnit(wrap, unit);
      updateSwitcherUI(switcher, unit);

      // Save preference for this domain only
      try { localStorage.setItem(STORAGE_KEY, unit); } catch (err) {}

    }, true);
  }

  // -----------------------------
  // INIT
  // -----------------------------
  function init() {
    var wrap     = $(WRAP_ID);
    var switcher = $(SWITCHER_ID);
    if (!wrap || !switcher) return;

    // Fix button visual state immediately (before table scan)
    // so there is no flash of wrong active button
    updateSwitcherUI(switcher, autoDefaultUnit());

    // Run first scan (handles tables already in the DOM)
    applyUnit(wrap, switcher);

    // Debounced MutationObserver — handles Ajax popup injection
    // 150 ms debounce gives the popup time to finish rendering all rows
    // before we attempt to scan, avoiding the race condition where
    // tBodies[0].rows is empty at the moment of the first scan attempt
    var moTimer = null;
    new MutationObserver(function () {
      clearTimeout(moTimer);
      moTimer = setTimeout(function () {
        var w = $(WRAP_ID);
        var s = $(SWITCHER_ID);
        if (w && s) applyUnit(w, s);
      }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  // -----------------------------
  // START
  // -----------------------------
  bindSwitcherDelegated();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();